/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ paths: NonNullable<unknown> }} Statement_Tree_Duplicate_Rows_Description__PathsInputs */

const en_statement_tree_duplicate_rows_description__paths = /** @type {(inputs: Statement_Tree_Duplicate_Rows_Description__PathsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Give each row a unique path: ${i?.paths}`)
};

const nl_statement_tree_duplicate_rows_description__paths = /** @type {(inputs: Statement_Tree_Duplicate_Rows_Description__PathsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geef elke rij een uniek pad: ${i?.paths}`)
};

/**
* | output |
* | --- |
* | "Give each row a unique path: {paths}" |
*
* @param {Statement_Tree_Duplicate_Rows_Description__PathsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
const statement_tree_duplicate_rows_description__paths = /** @type {((inputs: Statement_Tree_Duplicate_Rows_Description__PathsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Duplicate_Rows_Description__PathsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_duplicate_rows_description__paths(inputs)
	return en_statement_tree_duplicate_rows_description__paths(inputs)
});
export { statement_tree_duplicate_rows_description__paths as "statement_tree_duplicate_rows_description_$paths" }